import { useDispatch } from 'react-redux';
import { writeMessageActions } from '../_store';

const useCheckQuarantineWords = () => {
    const dispatch = useDispatch();

    const checkQuarantineWords = (inputText, dataList) => {
        const lowerInput = inputText?.toLowerCase() || "";
        const restrictedWords = dataList?.filter(item => item?.ActiveStatus !== 'InActive');

        const foundWords = restrictedWords?.filter(item => {
            const keyword = item?.MessageKeyword?.toLowerCase();
            if (!keyword) return false;

            if (item?.KeyWordFilterType === 'Whole Word') {
                const regex = new RegExp(`\\b${keyword}\\b`, 'i'); // whole word
                return regex.test(inputText);
            } else {
                return lowerInput.includes(keyword); // partial
            }
        });

        const uniqueWords = [...new Set(foundWords.map(w => w.MessageKeyword.toLowerCase()))];
        return uniqueWords;
    };

    const LoadQuarantineWords = async (subject, facilityID) => {
        const objData = {
            messageKeyword: subject,
            facilityID: facilityID,
            webUserSentAction: "",
            inmateSentAction: "",
            keyWordFilterType: "",
            activeStatus: 2,
            pageNo: 1,
            rowCountPerPage: 20,
            sortBy: "MessageKeyWord Desc",
        };
        return await dispatch(writeMessageActions.LoadKeywordList(objData)).then((x) => {
            if (x?.payload?.DataList?.length > 0) {
                let result = x?.payload?.DataList?.filter(item => item?.ActiveStatus == 'Active' && item?.WebUserSentAction == "Quarantine");
                const foundWords = checkQuarantineWords(subject, result);
                if (foundWords?.length > 0) {
                    const unique = [...new Set(foundWords)];
                    const keywordList = unique.join(", ");
                    return { isQuarantineWords: true, keywordList: keywordList }
                }
                else {
                    return { isQuarantineWords: false }
                }
            }
            else {
                return { isQuarantineWords: false }
            }

        });
    };

    return LoadQuarantineWords;
};


export default useCheckQuarantineWords;
